module.exports = __webpack_public_path__ + "media/images/team-f6a03cf495b35a0a27b742e585977fac.png";